module.exports = __webpack_public_path__ + "img/f40a2e4.png";